import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_ACTIVITIES_HOST_URL,
  withCredentials: true,
  headers: {
    accept: `application/json`,
  },
});

const setUpInterceptors = (getState, dispatch) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = getState()?.auth?.activityAccessToken;
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
};

const axiosBaseQuery =
  () =>
  async (
    { url, method, body, params, ...requestOpts },
    { getState, dispatch }
  ) => {
    setUpInterceptors(getState, dispatch);
    try {
      const axiosOptions = {
        url: url,
        method,
        data: body,
        params,
        headers: requestOpts.headers,
      };

      const result = await axiosInstance(axiosOptions);
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const esgactivites = createApi({
  reducerPath: "esgApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["esg"],
  endpoints: (builder) => ({
    GrigetToken: builder.mutation({
      query: () => ({
        url: `login`,
        method: "POST",
        body: {
          API_KEY: process.env.REACT_APP_ACTIVITIES_HOST_API_KEY,
        },
      }),
      invalidatesTags: ["esg"],
    }),

    Esgreportingperiod: builder.mutation({
      query: ({ token, body }) => {
        return {
          url: `/esg`,
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: body,
        };
      },
      invalidatesTags: ["esg"],
    }),
    Getesgactivity: builder.query({
      query: ({ token }) => {
        return {
          url: `/esg`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      providesTags: ["esg"],
    }),
    Getesdactivityid: builder.query({
      query: ({ id, token }) => {
        return {
          url: `/esg/${id}`,
          header: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
    }),
    AddesgformItem: builder.mutation({
      query: ({ reportId, token, payload }) => {
        return {
          url: `/esg/${reportId}/esg-item/upsert/`,
          method: "POST",
          body: payload,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      invalidatesTags: ["esg"],
    }),
    GetesgItemHistory: builder.query({
      query: ({ reportId, token }) => {
        if (!reportId) {
          return;
        }
        return {
          url: `/esg/${reportId}/esg-item/`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      providesTags: ["esg"],
    }),
    Deleteesgactivity: builder.mutation({
      query: ({ id, token }) => ({
        url: `/esg/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["esg"],
    }),
  }),
});

export const {
  useGrigetTokenMutation,
  useGetesgactivityQuery,
  useAddesgformItemMutation,
  useGetesgItemHistoryQuery,
  useEsgreportingperiodMutation,
  useDeleteesgactivityMutation,
} = esgactivites;
